import styled from 'styled-components';

const Divider = styled.div`
  width: 64px;
  height: 4px;
  border-radius: 2px;
  background-color: #f78323;
  margin-bottom: 16px;
`;

export default Divider;
